import { useTranslation } from 'react-i18next';
import bigman from '../../../../images/bigman.png'

const Structur = () => {
  const { i18n, t } = useTranslation();

  return (
    <section className="structur content-fix-index" id='structur'>
      <div className="structur__title">
        {i18n.language === 'en' ? (
          <><span>{t('structurTitle', { returnObjects: true })[0]}</span>{t('structurTitle', { returnObjects: true })[1]}</>
        ) : (
          <>{t('structurTitle', { returnObjects: true })[0]}<span>{t('structurTitle', { returnObjects: true })[1]}</span></>
        )}
        
      </div>

      <div className="structur__buttons">
        <div className="structur__buttons_conteiner">
          <div className="structur__buttons_item one">{t('strucrueVariants', { returnObjects: true })[0]}</div>
          <div className="structur__buttons_item two">{t('strucrueVariants', { returnObjects: true })[1]}</div>
          <div className="structur__buttons_item three">{t('strucrueVariants', { returnObjects: true })[2]}</div>
        </div>

        <div className="structur__buttons_conteiner">
          <div className="structur__buttons_item four">{t('strucrueVariants', { returnObjects: true })[3]}</div>
          <div className="structur__buttons_item five">{t('strucrueVariants', { returnObjects: true })[4]}</div>
          <div className="structur__buttons_item six">{t('strucrueVariants', { returnObjects: true })[5]} </div>
        </div>

        <img alt='man' src={bigman} className='structur__bigman'/>
      </div>
    </section>
  );
};

export default Structur;